import ConfidenceBadge from './ConfidenceBadge';
import MetricConfidenceBadge from './MetricConfidenceBadge';

export default ConfidenceBadge;

export { MetricConfidenceBadge };

export type { ConfidenceBadgeBand, IConfidenceBadgeProps } from './ConfidenceBadge';
export type {
  IMetricConfidenceBadgeProps,
  MetricConfidenceBand,
  MetricConfidencePlacement
} from './MetricConfidenceBadge';
export { CONFIDENCE_BAND_FLOORS, HANDOFF_CONFIDENCE_MINIMUM } from './MetricConfidenceBadge';
